import { fileTypeFromStream } from 'file-type'
const invalidCharactersRegex = /^\s+|[<>:"/\\|?*]|[.\s]+$/g

const safeFile = {

    mime: [
        'text/plain',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.presentation',
        'application/pdf',
        'application/rtf',
        'text/csv',
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/bm',
        'image/webp',
        'image/svg+xml',
        'image/tiff',
    ],

    extensions: ['msj'],

    sanitizeFilename: (filename = '') => filename.replace(invalidCharactersRegex, ''),

    fileType: async (file) => {

        const { mime = file.type, ext = file.name.split('.').pop() } = ((await fileTypeFromStream(file.stream())) ?? {})

        return { type: mime, ext }
    },

    secureFiles: async (files, filterBy) => {

        return (await Promise.all(files.map(async file =>  {

            if ( filterBy && !Array.isArray(filterBy) ) { filterBy = [filterBy] }

            const { type, ext } = await safeFile.fileType(file)

            const sanitizedFilename = file.name.replace(invalidCharactersRegex, '')

            if (sanitizedFilename !== file.name) file = new File([file], safeFile.sanitizeFilename(file.name), { type })

            if (safeFile.mime.includes(type) || safeFile.extensions.includes(ext) || (filterBy && filterBy.includes(file.ext))) return file

        }))).filter(f => f)
    }
}

export default safeFile